/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as AuthenticatedSettingsRouteImport } from './routes/_authenticated/settings'
import { Route as AuthenticatedKnowledgePacksRouteImport } from './routes/_authenticated/knowledge-packs'
import { Route as AuthenticatedAnalyticsRouteImport } from './routes/_authenticated/analytics'
import { Route as AuthenticatedGovernanceIndexRouteImport } from './routes/_authenticated/governance/index'
import { Route as AuthenticatedConversationsIndexRouteImport } from './routes/_authenticated/conversations/index'
import { Route as AuthenticatedAgentsIndexRouteImport } from './routes/_authenticated/agents/index'
import { Route as ConnectorsProviderSuccessRouteImport } from './routes/connectors/$provider.success'
import { Route as ConnectorsProviderErrorRouteImport } from './routes/connectors/$provider.error'
import { Route as AuthenticatedGovernanceAuditLogsRouteImport } from './routes/_authenticated/governance/audit-logs'
import { Route as AuthenticatedConversationsConversationIdRouteImport } from './routes/_authenticated/conversations/$conversationId'
import { Route as AuthenticatedConnectorsSplatRouteImport } from './routes/_authenticated/connectors/$'
import { Route as AuthenticatedChatAgentIdRouteImport } from './routes/_authenticated/chat/$agentId'
import { Route as AuthenticatedAgentsCreateRouteImport } from './routes/_authenticated/agents/create'
import { Route as AuthenticatedAgentsAgentIdRouteImport } from './routes/_authenticated/agents/$agentId'
import { Route as AuthenticatedAgentsAgentIdDraftsDraftIdRouteImport } from './routes/_authenticated/agents/$agentId_.drafts.$draftId'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedSettingsRoute = AuthenticatedSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedKnowledgePacksRoute =
  AuthenticatedKnowledgePacksRouteImport.update({
    id: '/knowledge-packs',
    path: '/knowledge-packs',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedAnalyticsRoute = AuthenticatedAnalyticsRouteImport.update({
  id: '/analytics',
  path: '/analytics',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedGovernanceIndexRoute =
  AuthenticatedGovernanceIndexRouteImport.update({
    id: '/governance/',
    path: '/governance/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedConversationsIndexRoute =
  AuthenticatedConversationsIndexRouteImport.update({
    id: '/conversations/',
    path: '/conversations/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedAgentsIndexRoute =
  AuthenticatedAgentsIndexRouteImport.update({
    id: '/agents/',
    path: '/agents/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const ConnectorsProviderSuccessRoute =
  ConnectorsProviderSuccessRouteImport.update({
    id: '/connectors/$provider/success',
    path: '/connectors/$provider/success',
    getParentRoute: () => rootRouteImport,
  } as any)
const ConnectorsProviderErrorRoute = ConnectorsProviderErrorRouteImport.update({
  id: '/connectors/$provider/error',
  path: '/connectors/$provider/error',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedGovernanceAuditLogsRoute =
  AuthenticatedGovernanceAuditLogsRouteImport.update({
    id: '/governance/audit-logs',
    path: '/governance/audit-logs',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedConversationsConversationIdRoute =
  AuthenticatedConversationsConversationIdRouteImport.update({
    id: '/conversations/$conversationId',
    path: '/conversations/$conversationId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedConnectorsSplatRoute =
  AuthenticatedConnectorsSplatRouteImport.update({
    id: '/connectors/$',
    path: '/connectors/$',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedChatAgentIdRoute =
  AuthenticatedChatAgentIdRouteImport.update({
    id: '/chat/$agentId',
    path: '/chat/$agentId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedAgentsCreateRoute =
  AuthenticatedAgentsCreateRouteImport.update({
    id: '/agents/create',
    path: '/agents/create',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedAgentsAgentIdRoute =
  AuthenticatedAgentsAgentIdRouteImport.update({
    id: '/agents/$agentId',
    path: '/agents/$agentId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedAgentsAgentIdDraftsDraftIdRoute =
  AuthenticatedAgentsAgentIdDraftsDraftIdRouteImport.update({
    id: '/agents/$agentId_/drafts/$draftId',
    path: '/agents/$agentId/drafts/$draftId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthenticatedIndexRoute
  '/login': typeof LoginRoute
  '/analytics': typeof AuthenticatedAnalyticsRoute
  '/knowledge-packs': typeof AuthenticatedKnowledgePacksRoute
  '/settings': typeof AuthenticatedSettingsRoute
  '/agents/$agentId': typeof AuthenticatedAgentsAgentIdRoute
  '/agents/create': typeof AuthenticatedAgentsCreateRoute
  '/chat/$agentId': typeof AuthenticatedChatAgentIdRoute
  '/connectors/$': typeof AuthenticatedConnectorsSplatRoute
  '/conversations/$conversationId': typeof AuthenticatedConversationsConversationIdRoute
  '/governance/audit-logs': typeof AuthenticatedGovernanceAuditLogsRoute
  '/connectors/$provider/error': typeof ConnectorsProviderErrorRoute
  '/connectors/$provider/success': typeof ConnectorsProviderSuccessRoute
  '/agents/': typeof AuthenticatedAgentsIndexRoute
  '/conversations/': typeof AuthenticatedConversationsIndexRoute
  '/governance/': typeof AuthenticatedGovernanceIndexRoute
  '/agents/$agentId/drafts/$draftId': typeof AuthenticatedAgentsAgentIdDraftsDraftIdRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/analytics': typeof AuthenticatedAnalyticsRoute
  '/knowledge-packs': typeof AuthenticatedKnowledgePacksRoute
  '/settings': typeof AuthenticatedSettingsRoute
  '/': typeof AuthenticatedIndexRoute
  '/agents/$agentId': typeof AuthenticatedAgentsAgentIdRoute
  '/agents/create': typeof AuthenticatedAgentsCreateRoute
  '/chat/$agentId': typeof AuthenticatedChatAgentIdRoute
  '/connectors/$': typeof AuthenticatedConnectorsSplatRoute
  '/conversations/$conversationId': typeof AuthenticatedConversationsConversationIdRoute
  '/governance/audit-logs': typeof AuthenticatedGovernanceAuditLogsRoute
  '/connectors/$provider/error': typeof ConnectorsProviderErrorRoute
  '/connectors/$provider/success': typeof ConnectorsProviderSuccessRoute
  '/agents': typeof AuthenticatedAgentsIndexRoute
  '/conversations': typeof AuthenticatedConversationsIndexRoute
  '/governance': typeof AuthenticatedGovernanceIndexRoute
  '/agents/$agentId/drafts/$draftId': typeof AuthenticatedAgentsAgentIdDraftsDraftIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteRouteWithChildren
  '/login': typeof LoginRoute
  '/_authenticated/analytics': typeof AuthenticatedAnalyticsRoute
  '/_authenticated/knowledge-packs': typeof AuthenticatedKnowledgePacksRoute
  '/_authenticated/settings': typeof AuthenticatedSettingsRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/agents/$agentId': typeof AuthenticatedAgentsAgentIdRoute
  '/_authenticated/agents/create': typeof AuthenticatedAgentsCreateRoute
  '/_authenticated/chat/$agentId': typeof AuthenticatedChatAgentIdRoute
  '/_authenticated/connectors/$': typeof AuthenticatedConnectorsSplatRoute
  '/_authenticated/conversations/$conversationId': typeof AuthenticatedConversationsConversationIdRoute
  '/_authenticated/governance/audit-logs': typeof AuthenticatedGovernanceAuditLogsRoute
  '/connectors/$provider/error': typeof ConnectorsProviderErrorRoute
  '/connectors/$provider/success': typeof ConnectorsProviderSuccessRoute
  '/_authenticated/agents/': typeof AuthenticatedAgentsIndexRoute
  '/_authenticated/conversations/': typeof AuthenticatedConversationsIndexRoute
  '/_authenticated/governance/': typeof AuthenticatedGovernanceIndexRoute
  '/_authenticated/agents/$agentId_/drafts/$draftId': typeof AuthenticatedAgentsAgentIdDraftsDraftIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/analytics'
    | '/knowledge-packs'
    | '/settings'
    | '/agents/$agentId'
    | '/agents/create'
    | '/chat/$agentId'
    | '/connectors/$'
    | '/conversations/$conversationId'
    | '/governance/audit-logs'
    | '/connectors/$provider/error'
    | '/connectors/$provider/success'
    | '/agents/'
    | '/conversations/'
    | '/governance/'
    | '/agents/$agentId/drafts/$draftId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/analytics'
    | '/knowledge-packs'
    | '/settings'
    | '/'
    | '/agents/$agentId'
    | '/agents/create'
    | '/chat/$agentId'
    | '/connectors/$'
    | '/conversations/$conversationId'
    | '/governance/audit-logs'
    | '/connectors/$provider/error'
    | '/connectors/$provider/success'
    | '/agents'
    | '/conversations'
    | '/governance'
    | '/agents/$agentId/drafts/$draftId'
  id:
    | '__root__'
    | '/_authenticated'
    | '/login'
    | '/_authenticated/analytics'
    | '/_authenticated/knowledge-packs'
    | '/_authenticated/settings'
    | '/_authenticated/'
    | '/_authenticated/agents/$agentId'
    | '/_authenticated/agents/create'
    | '/_authenticated/chat/$agentId'
    | '/_authenticated/connectors/$'
    | '/_authenticated/conversations/$conversationId'
    | '/_authenticated/governance/audit-logs'
    | '/connectors/$provider/error'
    | '/connectors/$provider/success'
    | '/_authenticated/agents/'
    | '/_authenticated/conversations/'
    | '/_authenticated/governance/'
    | '/_authenticated/agents/$agentId_/drafts/$draftId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRouteRoute: typeof AuthenticatedRouteRouteWithChildren
  LoginRoute: typeof LoginRoute
  ConnectorsProviderErrorRoute: typeof ConnectorsProviderErrorRoute
  ConnectorsProviderSuccessRoute: typeof ConnectorsProviderSuccessRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/settings': {
      id: '/_authenticated/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedSettingsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/knowledge-packs': {
      id: '/_authenticated/knowledge-packs'
      path: '/knowledge-packs'
      fullPath: '/knowledge-packs'
      preLoaderRoute: typeof AuthenticatedKnowledgePacksRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/analytics': {
      id: '/_authenticated/analytics'
      path: '/analytics'
      fullPath: '/analytics'
      preLoaderRoute: typeof AuthenticatedAnalyticsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/governance/': {
      id: '/_authenticated/governance/'
      path: '/governance'
      fullPath: '/governance/'
      preLoaderRoute: typeof AuthenticatedGovernanceIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/conversations/': {
      id: '/_authenticated/conversations/'
      path: '/conversations'
      fullPath: '/conversations/'
      preLoaderRoute: typeof AuthenticatedConversationsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/agents/': {
      id: '/_authenticated/agents/'
      path: '/agents'
      fullPath: '/agents/'
      preLoaderRoute: typeof AuthenticatedAgentsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/connectors/$provider/success': {
      id: '/connectors/$provider/success'
      path: '/connectors/$provider/success'
      fullPath: '/connectors/$provider/success'
      preLoaderRoute: typeof ConnectorsProviderSuccessRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/connectors/$provider/error': {
      id: '/connectors/$provider/error'
      path: '/connectors/$provider/error'
      fullPath: '/connectors/$provider/error'
      preLoaderRoute: typeof ConnectorsProviderErrorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/governance/audit-logs': {
      id: '/_authenticated/governance/audit-logs'
      path: '/governance/audit-logs'
      fullPath: '/governance/audit-logs'
      preLoaderRoute: typeof AuthenticatedGovernanceAuditLogsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/conversations/$conversationId': {
      id: '/_authenticated/conversations/$conversationId'
      path: '/conversations/$conversationId'
      fullPath: '/conversations/$conversationId'
      preLoaderRoute: typeof AuthenticatedConversationsConversationIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/connectors/$': {
      id: '/_authenticated/connectors/$'
      path: '/connectors/$'
      fullPath: '/connectors/$'
      preLoaderRoute: typeof AuthenticatedConnectorsSplatRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/chat/$agentId': {
      id: '/_authenticated/chat/$agentId'
      path: '/chat/$agentId'
      fullPath: '/chat/$agentId'
      preLoaderRoute: typeof AuthenticatedChatAgentIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/agents/create': {
      id: '/_authenticated/agents/create'
      path: '/agents/create'
      fullPath: '/agents/create'
      preLoaderRoute: typeof AuthenticatedAgentsCreateRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/agents/$agentId': {
      id: '/_authenticated/agents/$agentId'
      path: '/agents/$agentId'
      fullPath: '/agents/$agentId'
      preLoaderRoute: typeof AuthenticatedAgentsAgentIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/agents/$agentId_/drafts/$draftId': {
      id: '/_authenticated/agents/$agentId_/drafts/$draftId'
      path: '/agents/$agentId/drafts/$draftId'
      fullPath: '/agents/$agentId/drafts/$draftId'
      preLoaderRoute: typeof AuthenticatedAgentsAgentIdDraftsDraftIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
  }
}

interface AuthenticatedRouteRouteChildren {
  AuthenticatedAnalyticsRoute: typeof AuthenticatedAnalyticsRoute
  AuthenticatedKnowledgePacksRoute: typeof AuthenticatedKnowledgePacksRoute
  AuthenticatedSettingsRoute: typeof AuthenticatedSettingsRoute
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedAgentsAgentIdRoute: typeof AuthenticatedAgentsAgentIdRoute
  AuthenticatedAgentsCreateRoute: typeof AuthenticatedAgentsCreateRoute
  AuthenticatedChatAgentIdRoute: typeof AuthenticatedChatAgentIdRoute
  AuthenticatedConnectorsSplatRoute: typeof AuthenticatedConnectorsSplatRoute
  AuthenticatedConversationsConversationIdRoute: typeof AuthenticatedConversationsConversationIdRoute
  AuthenticatedGovernanceAuditLogsRoute: typeof AuthenticatedGovernanceAuditLogsRoute
  AuthenticatedAgentsIndexRoute: typeof AuthenticatedAgentsIndexRoute
  AuthenticatedConversationsIndexRoute: typeof AuthenticatedConversationsIndexRoute
  AuthenticatedGovernanceIndexRoute: typeof AuthenticatedGovernanceIndexRoute
  AuthenticatedAgentsAgentIdDraftsDraftIdRoute: typeof AuthenticatedAgentsAgentIdDraftsDraftIdRoute
}

const AuthenticatedRouteRouteChildren: AuthenticatedRouteRouteChildren = {
  AuthenticatedAnalyticsRoute: AuthenticatedAnalyticsRoute,
  AuthenticatedKnowledgePacksRoute: AuthenticatedKnowledgePacksRoute,
  AuthenticatedSettingsRoute: AuthenticatedSettingsRoute,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedAgentsAgentIdRoute: AuthenticatedAgentsAgentIdRoute,
  AuthenticatedAgentsCreateRoute: AuthenticatedAgentsCreateRoute,
  AuthenticatedChatAgentIdRoute: AuthenticatedChatAgentIdRoute,
  AuthenticatedConnectorsSplatRoute: AuthenticatedConnectorsSplatRoute,
  AuthenticatedConversationsConversationIdRoute:
    AuthenticatedConversationsConversationIdRoute,
  AuthenticatedGovernanceAuditLogsRoute: AuthenticatedGovernanceAuditLogsRoute,
  AuthenticatedAgentsIndexRoute: AuthenticatedAgentsIndexRoute,
  AuthenticatedConversationsIndexRoute: AuthenticatedConversationsIndexRoute,
  AuthenticatedGovernanceIndexRoute: AuthenticatedGovernanceIndexRoute,
  AuthenticatedAgentsAgentIdDraftsDraftIdRoute:
    AuthenticatedAgentsAgentIdDraftsDraftIdRoute,
}

const AuthenticatedRouteRouteWithChildren =
  AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,
  LoginRoute: LoginRoute,
  ConnectorsProviderErrorRoute: ConnectorsProviderErrorRoute,
  ConnectorsProviderSuccessRoute: ConnectorsProviderSuccessRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
